import React, { Fragment } from "react";
import { images } from "../../../common/Images";
import { Colors } from "../../../common/Const";
import { Carousel } from "antd";
import String from "../../../lang/String";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import { Pagination } from "swiper";
import { AspectRatio } from "@mui/icons-material";
import SkeletonEffect from "./SkeletonEffect";
import { positions } from "@mui/system";

function PromoVideos(props) {
  const { promoData } = props;

  return (
    promoData.length  > 0 ?<div className="container my-4">
      <p className="h3 text-center my-4" style={{ color: Colors.Base_color }}>
       {String.home_headings.promo_videos}
      </p>
      <div className="row  p-0">
        <div className="col-1 p-0 d-flex align-items-center justify-content-center">
      <img
          className=" promo-swiper-button-prev p-1"
          src={images.left}
          alt="left"
          width="30"
          height="30"
          role={"button"}
        />
        </div>
      <div
        className="col-10 p-2 vdo-box"
        style={{
          border: `3px solid ${Colors.Base_color}`
        }}
      >
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          navigation={{
            nextEl: ".promo-swiper-button-next",
            prevEl: ".promo-swiper-button-prev",
          }}
          modules={[Navigation]}
          className="mySwiper"
        >
          {promoData && promoData != null && (
            promoData.map((data) => {
              return (
                <SwiperSlide key={data.id}>
                <div className="ratio ratio-16x9">
                  <iframe
                    style={{ borderRadius: "30px" }}
                    src={data.video_url}
                    title="YouTube video"
                    allowfullscreen="allowfullscreen"
                  ></iframe>
                </div>
                </SwiperSlide>
              );
            })
          )}
          </Swiper>
      </div>
      <div className="col-1 p-0 d-flex align-items-center justify-content-center">
      <img
          className="promo-swiper-button-next p-1"
          src={images.right}
          alt="left"
          width="30"
          height="30"
          role={"button"}
        />
        </div>
        </div>
      <p className="text-secondary my-3 text-center fs-5 sell-p">
        {String.home_headings.best_light_weight_collections}
      </p>
    </div>:null
  );
}

export default PromoVideos;
